module.exports = __webpack_public_path__ + "img/practice-2.c6c5b063.jpg";